<div class="px-3">
    <div class="row mb-2 align-items-start">
        <div class="col-md-6 col-lg-4 mb-2">
            <iim-card [header]="'Anfrageinformationen' | translate">
                <div class="mb-2">
                    <div class="row">
                        <div class="col">
                            <strong>{{ 'Titel' | translate }}</strong>
                        </div>
                        <div class="col-auto">
                            {{ preview.demand.title }}
                        </div>
                    </div>
                    @if (preview.displayNumber) {
                        <div class="row">
                            <div class="col">
                                <strong>{{ 'Nummer' | translate }}</strong>
                            </div>
                            <div class="col-auto" copyToClipboard>
                                {{ preview.displayNumber }}
                            </div>
                        </div>
                    }
                    <div class="row">
                        <div class="col">
                            <strong>{{ 'Bedarfsträger' | translate }}</strong>
                        </div>
                        <div class="col-auto">
                            {{ preview.demand.consumer | person }}
                        </div>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col">
                        <strong>{{ 'Status' | translate }}</strong>
                    </div>
                    <div class="col-auto">
                        <purchase-requisition-status-display
                            [status]="preview.status.value"
                        ></purchase-requisition-status-display>
                    </div>
                </div>
                @if (preview.demand.suppliers.length > 0) {
                    <div class="row mb-2">
                        <div class="col">
                            <strong>{{ 'Lieferant(en)' | translate }}</strong>
                        </div>
                        <div class="col">
                            <ul class="list-group">
                                @for (supplier of preview.demand.suppliers; track supplier) {
                                    <li class="list-group-item p-1 font-08">
                                        <strong>
                                            <em class="fas fa-truck"></em>
                                            {{
                                                supplier.contact.companyName
                                                    | supplierDisplayName: supplier.supplierNumber
                                            }}
                                        </strong>
                                        <br />
                                        @if (
                                            supplier.contact?.contact &&
                                            (supplier.contact.contact.firstName ||
                                                supplier.contact.contact.surName)
                                        ) {
                                            <span>
                                                <em class="fas fa-user"></em>
                                                {{ supplier.contact.contact | person }}
                                            </span>
                                        } @else {
                                            {{ 'Standard Ansprechpartner' | translate }}
                                        }
                                    </li>
                                }
                            </ul>
                        </div>
                    </div>
                }
                @if (preview.rfqs.length > 0 || preview.orders.length > 0) {
                    <div class="row mb-2">
                        <div class="col">
                            <strong>{{ 'Resultate' | translate }}</strong>
                        </div>
                        <div class="col-auto">
                            @if (preview.rfqs?.length > 0) {
                                <div class="row">
                                    <div class="col">
                                        <span class="fw-bold mb-2">
                                            {{ 'Anfragen' | translate }}
                                        </span>
                                        @for (doc of preview.rfqs; track doc) {
                                            <app-processed-status-display
                                                [label]="doc.displayValue"
                                                [statusId]="doc.statusId"
                                                [clickable]="doc.navigatable && rfqLinkAllowed"
                                                (statusClicked)="navigateToResult(doc)"
                                            ></app-processed-status-display>
                                        }
                                    </div>
                                </div>
                            }
                            @if (preview.orders?.length > 0) {
                                <div class="row">
                                    <div class="col">
                                        <span class="font-11 fw-bold mb-2">
                                            {{ 'Bestellungen' | translate }}
                                        </span>
                                        @for (doc of preview.orders; track doc) {
                                            <app-processed-status-display
                                                [label]="doc.displayValue"
                                                [statusId]="doc.statusId"
                                                [clickable]="doc.navigatable && orderLinkAllowed"
                                                (statusClicked)="navigateToResult(doc)"
                                            ></app-processed-status-display>
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                }
            </iim-card>
        </div>
        <div class="col">
            <iim-card [header]="'Inhalt' | translate" [footer]="itemsFooter">
                @for (item of preview.demand.products; track item) {
                    <div class="row mb-1">
                        <div class="col">
                            <div class="article">
                                <div class="row mx-auto">
                                    <div class="col">
                                        <h4>
                                            {{ item.name }}
                                        </h4>
                                        <p class="text-description font-09">{{ item.description }}</p>
                                        <ng-template let-data="data" let-label="label" let-copy="copy" #itemRow>
                                            @if (data) {
                                                <div class="row">
                                                    <div class="col-lg-4 col-md-12">
                                                        <strong>{{ label }}</strong>
                                                    </div>
                                                    <div class="col-auto" copyToClipboard [copyingActive]="!!copy">
                                                        {{ data }}
                                                    </div>
                                                </div>
                                            }
                                        </ng-template>
                                        <div class="mb-1">
                                            <ng-container
                                                *ngTemplateOutlet="
                                                    itemRow;
                                                    context: {
                                                        data: item.articleNumber,
                                                        label: 'Artikelnummer' | translate,
                                                        copy: true,
                                                    }
                                                "
                                            ></ng-container>
                                        </div>
                                        <div class="mb-1">
                                            <ng-container
                                                *ngTemplateOutlet="
                                                    itemRow;
                                                    context: {
                                                        data: item.supplierArticleNumber,
                                                        label: 'Artikelnummer Lieferant' | translate,
                                                        copy: true,
                                                    }
                                                "
                                            ></ng-container>
                                        </div>
                                        <div class="mb-1">
                                            <ng-container
                                                *ngTemplateOutlet="
                                                    itemRow;
                                                    context: {
                                                        data: item.manufacturer,
                                                        label: 'Hersteller' | translate,
                                                    }
                                                "
                                            ></ng-container>
                                            <ng-container
                                                *ngTemplateOutlet="
                                                    itemRow;
                                                    context: {
                                                        data: item.manufacturerArticleNumber,
                                                        label: 'Artikelnummer Hersteller' | translate,
                                                        copy: true,
                                                    }
                                                "
                                            ></ng-container>
                                        </div>
                                    </div>
                                    <div class="col-auto align-self-end justify-content-end">
                                        <div class="row align-items-center justify-content-end">
                                            <div class="col-auto">
                                                <span class="font-12 fw-bold">
                                                    {{ item.quantity }} {{ item.orderUnit | unit: item.quantity }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                <ng-template #itemsFooter>
                    <div class="col">
                        @for (price of preview.demand.price; track price) {
                            <div class="row mb-2 justify-content-end">
                                <div class="col-lg-3 col-md-6 col-sm-12">
                                    <div class="row">
                                        <div class="col">
                                            <strong>{{ 'Preis Netto' | translate }}</strong>
                                        </div>
                                        <div class="col-auto"><display-currency [value]="price.netPrice" [currencyCode]="price.currency" /></div>
                                    </div>
                                    @for (tax of price.tax; track tax) {
                                        <div class="row">
                                            <div class="col">
                                                <strong>
                                                    {{
                                                        'zzgl. MwSt. \{\{percent\}\}%'
                                                            | translate: { percent: tax.rate }
                                                    }}
                                                </strong>
                                            </div>
                                            <div class="col-auto"><display-currency [value]="tax.amount" [currencyCode]="price.currency" /></div>
                                        </div>
                                    }
                                    <div class="row">
                                        <div class="col">
                                            <strong>{{ 'Preis Brutto' | translate }}</strong>
                                        </div>
                                        <div class="col-auto"><display-currency [value]="price.grossPrice" [currencyCode]="price.currency" /></div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </ng-template>
            </iim-card>
        </div>
    </div>
</div>
